import {XyGisCrudService} from '../../core/services'
import {IXyApplyEditsResult, ISourceApplyEdits} from '../../core/interfaces/services'
import {FeatureStatus, Feature, FeatureLayerInfo, Polygon} from '../../core/models'
import appConfig from '../../reducers/appConfig'
import {getMapService} from '../../core/reducers/map'
import {IQuery} from '../../core/interfaces/models'

export class AppXYGisCrudService extends XyGisCrudService {
  protected modGeometry(layerInfo: FeatureLayerInfo, query: IQuery) {
    if (query.geometry) {
      ;(query.geometry as any) = {
        SRID: getMapService().getSRID(),
        Coordinates: (query.geometry as Polygon)
          .getCoordinates()
          .map(ring => ring.map((c: any) => ({X: c[0], Y: c[1]})))[0]
      }
    }
  }

  public executeForCount(layerInfo: FeatureLayerInfo, query: IQuery): Promise<number> {
    return super.executeForCount(layerInfo, query)
  }

  public execute(layerInfo: FeatureLayerInfo, query: IQuery): Promise<Array<Feature>> {
    return super.execute(layerInfo, query)
  }

  protected afterPostEdits(
    r: IXyApplyEditsResult,
    adds: {[namespace: string]: {[featureType: string]: {[guid: string]: Feature}}},
    applyEdits: ISourceApplyEdits[],
    resolve: (r: any) => void
  ) {
    const guidMap: {[guid: string]: number} = {}
    for (const namespace in r) {
      for (const featureType in r[namespace]) {
        for (const guid in r[namespace][featureType]) {
          const id = r[namespace][featureType][guid]
          const feature = adds[namespace][featureType][guid]
          guidMap[guid] = id
          feature.setId(id)
        }
      }
    }
    applyEdits.forEach(a => {
      if (appConfig.reg.regrelated.indexOf(a.layerInfo.url) != -1 && a.updates) {
        if (!a.deletes) a.deletes = []
        const newUpdates: Feature[] = [...a.updates]
        a.updates.forEach(u => {
          if ((u.getProperties()['RegPlanId'] as any).toString() === '0') {
            a.deletes!.push(u)
          } else {
            newUpdates.push(u)
          }
        })
        a.updates = newUpdates
        const info = a.layerInfo
        this.convertAttachmentLinks(a.adds || [], a.layerInfo)
        this.convertAttachmentLinks(a.updates || [], a.layerInfo)
        if (a.adds)
          a.adds.forEach(a => {
            a.set(info.sourceDescription.idField, guidMap[a.getId()])
            a.status = FeatureStatus.Unchanged
            a.attachmentChanges = {adds: {}, deletes: {}, updates: {}}
          })
        if (a.updates)
          a.updates.forEach(a => {
            a.status = FeatureStatus.Unchanged
            a.attachmentChanges = {adds: {}, deletes: {}, updates: {}}
          })
        if (a.deletes)
          a.deletes.forEach(a => {
            a.status = FeatureStatus.Deleted
            a.attachmentChanges = {adds: {}, deletes: {}, updates: {}}
          })
      } else {
        this.convertAttachmentLinks(a.adds || [], a.layerInfo)
        this.convertAttachmentLinks(a.updates || [], a.layerInfo)
        if (a.adds)
          a.adds.forEach(a => {
            a.status = FeatureStatus.Unchanged
            a.attachmentChanges = {adds: {}, deletes: {}, updates: {}}
          })
        if (a.updates)
          a.updates.forEach(a => {
            a.status = FeatureStatus.Unchanged
            a.attachmentChanges = {adds: {}, deletes: {}, updates: {}}
          })
        if (a.deletes)
          a.deletes.forEach(a => {
            a.status = FeatureStatus.Deleted
            a.attachmentChanges = {adds: {}, deletes: {}, updates: {}}
          })
      }
    })
    applyEdits.forEach(a => a.layerInfo.refresh())
    setTimeout(() => {
      resolve(applyEdits)
    }, 500)
  }
}
